import {ChangeDetectorRef, Component, inject, OnDestroy, OnInit} from "@angular/core";
import {
    ControlContainer,
    UntypedFormBuilder as FormBuilder,
    UntypedFormGroup as FormGroup,
    Validators
} from "@angular/forms";
import {Subscription} from "rxjs";
import {DialogRef} from "@fundamental-ngx/core/dialog";

export const STEP_BEGIN_FORM_GROUPS = {
    STEP_BEGIN: "stepBegin"
};

export const STEP_BEGIN_FORM_CONTROLS = {
    ACKNOWLEDGED: "acknowledged"
};

@Component({
    selector: "app-unified-step-begin",
    templateUrl: "./unified-step-begin.component.html",
    styleUrls: ["./unified-step-begin.component.scss"],
    standalone: false
})
export class UnifiedStepBeginComponent implements OnInit, OnDestroy {
    public dialogRef: DialogRef = inject(DialogRef);
    private readonly controlContainer: ControlContainer = inject(ControlContainer);
    private readonly fb: FormBuilder = inject(FormBuilder);
    private readonly cdRef: ChangeDetectorRef = inject(ChangeDetectorRef);

    readonly STEP_BEGIN_FORM_GROUPS = STEP_BEGIN_FORM_GROUPS;
    readonly STEP_BEGIN_FORM_CONTROLS = STEP_BEGIN_FORM_CONTROLS;
    public form: FormGroup;

    subscriptions: Subscription[] = [];

    constructor() {
    }

    ngOnInit() {
        this.form = <FormGroup>this.controlContainer.control;
        this.initControls();
    }

    initControls() {
        this.form.addControl(STEP_BEGIN_FORM_GROUPS.STEP_BEGIN, this.fb.group({
            [STEP_BEGIN_FORM_CONTROLS.ACKNOWLEDGED]: [false, Validators.requiredTrue]
        }));
    }

    getStepBeginFormGroup() {
        return this.form.get(STEP_BEGIN_FORM_GROUPS.STEP_BEGIN) as FormGroup;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
